<template>
	<div v-if="data" class="booker-bar">
		<div class="booker-bar__content">
			<div v-if="data.icon">
				<GlobalIcon :name="data.icon" :height="18" />
			</div>
			<div class="booker-bar__data">
				<div v-if="data.title" class="booker-bar__title">{{ data.title }}</div>
				<div v-if="data.desc" class="booker-bar__desc">
					{{ data.desc }}
					<ButtonUnderlined v-if="data.button" class="booker-bar__btn" @click="btnClick">{{ data.button.title }}</ButtonUnderlined>
				</div>
			</div>
		</div>
		<div v-if="!notCloseable" class="booker-bar__close">
			<ButtonIcon class="booker-bar__close-icon" @click="closeBar"> <GlobalIcon name="close" :height="18" /> </ButtonIcon>
		</div>
	</div>
</template>

<script lang="ts" setup>
const route = useRoute()
const router = useRouter()
// const bookerStore = useBookerStore()
const bookingStore = useBookingStore()
const props = defineProps<{
	data: any
	notCloseable?: boolean
}>()

const closeBar = () => {
	emit('closeBar')
}

const btnClick = async () => {
	// check if button has link and if user is not on the same page as the link
	bookingStore.updateSelectedCar(null)
	// bookingStore.setBookerDates({ start: null, end: null })
	await bookingStore.updateBooking()
	if (props.data.button.link && route.path !== props.data.button.link) {
		// bookerStore.setIsStartDateMenuOpen(false)
		router.push(props.data.button.link)
	}
}

const emit = defineEmits<{
	(e: 'closeBar'): void
}>()
</script>

<style lang="scss">
@import './InfoBar';
</style>
